// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yR6j","largestCol":"styles_largestCol__RHWS8","smallestCol":"styles_smallestCol__2EBcb"};